// extracted by mini-css-extract-plugin
export default {"wrapper":"MakeModelCell_wrapper__F0CXM","make":"MakeModelCell_make__7WuSl","model":"MakeModelCell_model__3FV+l"};